/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerRemoveMutationResponse, DepartmentsControllerRemovePathParams, DepartmentsControllerRemove401, DepartmentsControllerRemove403, DepartmentsControllerRemove404 } from "../../models/departmentsController/DepartmentsControllerRemove";

function getDepartmentsControllerRemoveUrl(id: DepartmentsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/departments/${id}` as const }  
  return res
}

/**
 * @summary Delete a department
 * {@link /api/v1/departments/:id}
 */
export async function departmentsControllerRemove(id: DepartmentsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DepartmentsControllerRemoveMutationResponse, ResponseErrorConfig<DepartmentsControllerRemove401 | DepartmentsControllerRemove403 | DepartmentsControllerRemove404>, unknown>({ method : "DELETE", url : getDepartmentsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}